export default "__VITE_ASSET__mGKZmXpQ__"